import { Loader2 } from "lucide-react";

export const inputCls =
  "w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-400/30 transition-colors";

export const Label = ({ children, htmlFor }) => (
  <label htmlFor={htmlFor} className="mb-2 block font-mono text-[10px] tracking-[0.25em] uppercase text-slate-500">{children}</label>
);

export const Button = ({ children, variant = "primary", loading, className = "", ...props }) => {
  const base = "inline-flex items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold active:scale-95 disabled:opacity-60 disabled:active:scale-100 transition-all duration-300";
  const styles = {
    primary: "bg-[#0B1528] text-white hover:bg-amber-500 hover:text-[#0B1528]",
    ghost: "border border-slate-300 bg-white text-slate-700 hover:border-amber-500 hover:text-amber-600",
    danger: "border border-red-200 bg-red-50 text-red-600 hover:bg-red-600 hover:text-white",
    amber: "bg-amber-500 text-[#0B1528] hover:bg-[#0B1528] hover:text-white",
  };
  return (
    <button className={`${base} ${styles[variant]} ${className}`} disabled={loading || props.disabled} {...props}>
      {loading && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </button>
  );
};

export const Card = ({ children, className = "", ...props }) => (
  <div className={`rounded-2xl border border-slate-200 bg-white p-6 shadow-sm ${className}`} {...props}>{children}</div>
);

export const PageHeader = ({ eyebrow, title, sub, actions }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
    <div>
      <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-amber-600 mb-2">{eyebrow}</p>
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0B1528]">{title}</h1>
      {sub && <p className="mt-2 text-sm text-slate-500 max-w-2xl">{sub}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const Badge = ({ children, tone = "slate" }) => {
  const tones = {
    slate: "bg-slate-100 text-slate-600 border-slate-200",
    amber: "bg-amber-100 text-amber-700 border-amber-300",
    green: "bg-emerald-100 text-emerald-700 border-emerald-300",
    red: "bg-red-100 text-red-700 border-red-300",
    blue: "bg-blue-100 text-blue-700 border-blue-300",
  };
  return <span className={`inline-flex rounded-full border px-2.5 py-0.5 font-mono text-[10px] tracking-[0.15em] uppercase ${tones[tone]}`}>{children}</span>;
};

export const Empty = ({ children }) => (
  <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-10 text-center text-sm text-slate-500">{children}</div>
);

export const Spinner = () => (
  <div className="flex items-center justify-center py-20 text-slate-400"><Loader2 className="h-6 w-6 animate-spin" /></div>
);
